"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopoverComboboxOptions = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const cmdk_1 = require("cmdk");
const utils_1 = require("@bemlo/utils");
const constants_1 = require("../../../constants");
const translate_1 = require("../../../translate");
const Avatar_1 = require("../../Avatar");
const Badge_1 = require("../../Badge");
const Checkbox_1 = require("../../Checkbox");
const Div_1 = require("../../Div");
const Flex_1 = require("../../Flex");
const Icon_1 = require("../../Icon");
const SelectedCheckmark_1 = require("../SelectedCheckmark");
const Options = (0, styled_1.default)(cmdk_1.Command.List)({
    borderTop: constants_1.theme.border.style.thinLight,
    maxHeight: 400,
    overflow: 'auto',
    overscrollBehavior: 'contain',
});
const Group = (0, styled_1.default)(cmdk_1.Command.Group, {
    shouldForwardProp: (prop) => prop !== 'hasGroupLabels',
}) `
  :not(:first-of-type) {
    border-top: ${({ hasGroupLabels }) => hasGroupLabels ? 'none' : constants_1.theme.border.style.thinLight};
  }

  [cmdk-group-heading] {
    user-select: none;
    font-size: 12px;
    color: ${constants_1.Color.DARKEST_MEDIUM_GREY};
    padding: 8px 16px;
    display: flex;
    align-items: center;
    font-weight: ${constants_1.theme.font.weight.bold};
  }
`;
const Option = (0, styled_1.default)(cmdk_1.Command.Item) `
  font: inherit;
  font-size: 14px;
  gap: 12px;
  padding: 8px;
  padding: ${constants_1.theme.padding.button.small.y}px ${constants_1.theme.padding.button.small.x}px;
  overflow: hidden;
  user-select: none;
  color: ${constants_1.Color.BLACK};
  cursor: pointer;
  /* Hide checkbox unless selected or highlighted */
  input {
    display: ${({ selected }) => (selected ? 'block' : 'none')};
  }
  &[data-selected='true'] {
    background: ${constants_1.Color.LIGHTEST_BLUE};
    color: ${constants_1.Color.CHARCOAL};
    /* Show checkbox if highlighted */
    input {
      display: block;
    }
    svg {
      color: ${constants_1.Color.DARKER_GREY};
    }
  }
  &[data-disabled='true'] {
    /* TODO: cannot disable yet - improve styling */
    cursor: not-allowed;
  }
  &:active {
    transition-property: background;
    background: ${constants_1.Color.DARK_MEDIUM_GREY};
  }
  svg {
    color: ${constants_1.Color.DARK_GREY};
  }
`;
const OptionContent = styled_1.default.div({
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    p: {
        margin: 0,
    },
});
const NoItemsFound = (0, styled_1.default)(cmdk_1.Command.Empty)({
    padding: `${constants_1.theme.padding.button.medium.y}px ${constants_1.theme.padding.button.medium.x}px`,
    color: constants_1.Color.DARK_GREY,
    fontSize: 14,
    fontWeight: constants_1.theme.font.weight.legacy[500],
    textAlign: 'center',
});
const PopoverComboboxOptions = ({ actionsSlot, groups, noItemsFoundLabel, onSelect, type, value, }) => {
    const t = (0, translate_1.useTranslations)();
    const optionsGroups = (0, utils_1.toArray)(groups);
    const selectedOptions = (0, utils_1.toArray)(value).filter(utils_1.isTruthy);
    const isMultiSelect = type === 'multiSelect';
    const isSingleSelect = type === 'singleSelect';
    const hasGroupLabels = optionsGroups.some((group) => group.label);
    const hasUser = optionsGroups.some((group) => group.items.some((item) => item.user));
    return ((0, jsx_runtime_1.jsxs)(Options, { children: [(0, jsx_runtime_1.jsx)(NoItemsFound, { children: noItemsFoundLabel ?? t.form.no_alternatives() }), optionsGroups.map((group, index) => ((0, jsx_runtime_1.jsx)(Group, { heading: group.label, hasGroupLabels: hasGroupLabels, children: group.items.map(({ icon, label, value, user, badgeColor }) => {
                    const isSelected = selectedOptions.includes(value);
                    return ((0, jsx_runtime_1.jsx)(Option, { value: label, onSelect: () => onSelect(value), selected: isSelected, children: (0, jsx_runtime_1.jsxs)(OptionContent, { children: [isMultiSelect && ((0, jsx_runtime_1.jsx)(Checkbox_1.Checkbox, { checked: isSelected, size: "sm", variant: "inverted" })), icon && ((0, jsx_runtime_1.jsx)(Flex_1.Flex, { styles: {
                                        height: hasUser ? 24 : 16,
                                        width: hasUser ? 24 : 16,
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }, children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: icon, size: "sm" }) })), user && ((0, jsx_runtime_1.jsx)(Avatar_1.Avatar, { name: user.name, image: user.avatarUrl, type: user.avatarUrl ? 'image' : 'initials', size: "xs" })), badgeColor ? ((0, jsx_runtime_1.jsx)(Badge_1.Badge, { color: badgeColor, size: "sm", children: label })) : ((0, jsx_runtime_1.jsx)("p", { children: label })), isSingleSelect && ((0, jsx_runtime_1.jsx)(SelectedCheckmark_1.SelectedCheckmark, { selected: isSelected }))] }) }, value));
                }) }, index))), actionsSlot && ((0, jsx_runtime_1.jsx)(Div_1.Div, { styles: { borderTop: constants_1.theme.border.style.thin, p: 2 }, children: actionsSlot }))] }));
};
exports.PopoverComboboxOptions = PopoverComboboxOptions;
